/* eslint-disable max-len */
import React from "react"
import BaseSvgIcon from "./Base"

const AddBookmark = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 12 15">
      <g id="3.-View-results" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g
          id="View-results,-comments---bookmark-and-sentiment-analysis"
          transform="translate(-1215.000000, -730.000000)"
          stroke="#3D3D35"
          strokeWidth="1.3">
          <g id="Group-Copy-4" transform="translate(1203.000000, 719.000000)">
            <g id="Bookmark" transform="translate(13.000000, 11.000000)">
              <polygon id="Path" points="0.18 0.97 10.33 0.97 10.33 13.99 5.18 9.5 0.19 14.14" />
            </g>
          </g>
        </g>
      </g>
    </BaseSvgIcon>
  )
}

export default AddBookmark
